export default {
  SUCCESS: "success",
  WARNING: "warning"
}